import { motion } from "framer-motion";

export const LogoMark = ({ className = "h-10", dark = false }) => (
  <span
    className={`inline-flex items-center justify-center overflow-hidden rounded-xl ${
      dark ? "bg-white px-2.5 py-1.5" : ""
    }`}
  >
    <img src="/logo-mark-transparent.png" alt="Símbolo Clínica COB" className={`${className} w-auto object-contain`} />
  </span>
);

export const Logo = ({ dark = false, compact = false }) => (
  <a href="#inicio" data-testid="logo-link" className="flex items-center gap-3 group">
    <motion.span
      initial={{ opacity: 0, scale: 0, rotate: -140 }}
      animate={{ opacity: 1, scale: 1, rotate: 0 }}
      transition={{ type: "spring", stiffness: 180, damping: 15, delay: 0.15 }}
      className="inline-flex items-center justify-center overflow-hidden rounded-xl transition-transform duration-500 group-hover:-rotate-2"
    >
      <motion.span
        animate={{ rotate: [0, 0, -6, 0] }}
        transition={{ duration: 1.2, delay: 1.1, times: [0, 0.7, 0.85, 1], ease: "easeInOut" }}
        className="inline-flex"
      >
        <img
          src={dark ? "/logo-mark-white.png" : "/logo-mark-transparent.png"}
          alt="Clínica COB"
          className={`${compact ? "h-8" : "h-10"} w-auto object-contain transition-[height] duration-500`}
        />
      </motion.span>
    </motion.span>
    {!compact && (
      <span className="hidden xl:flex flex-col leading-none overflow-hidden">
        <motion.span
          initial={{ opacity: 0, x: -18, filter: "blur(4px)" }}
          animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
          transition={{ duration: 0.7, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className={`font-serif font-semibold text-lg tracking-wide ${dark ? "text-white" : "text-cob-dark"}`}
        >
          Clínica Ortopédica Buenos Aires
        </motion.span>
        <motion.span
          initial={{ opacity: 0, x: -18, filter: "blur(4px)" }}
          animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
          transition={{ duration: 0.7, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mt-1 text-[9px] font-semibold tracking-[0.2em] text-cob-gold uppercase"
        >
          Ortopedia • Fisioterapia • Medicina
        </motion.span>
      </span>
    )}
  </a>
);
